import ApiService from 'utils/ApiCalls';
import { Dispatch } from '@reduxjs/toolkit';
import { LanguageList } from '../globalTypes';
import internalControlsSlice from './internalControlsSlice';

const {
  set_loading,
  set_draw_table,
  set_selected_entity_id,
  set_save_disabled,
  set_has_changes
} = internalControlsSlice.actions;

const applyFiltersApi = async (
  lang: LanguageList,
  filters: Record<string, string[]>
) => {
  try {
    const response = await ApiService.applyFilters(lang, filters);
    return response.data || [];
  } catch (error) {
    return [];
  }
};

const setDrawTable = (draw: boolean) => (dispatch: Dispatch) => {
  try {
    dispatch(set_loading());
    dispatch(set_draw_table(draw));
  } catch (error) {
    console.error(error);
  }
};

const setSelectedEntityId =
  (entityId: number | undefined) => (dispatch: Dispatch) => {
    dispatch(set_selected_entity_id(entityId));
  };

const setSaveDisabled = (disabled: boolean) => (dispatch: Dispatch) => {
  dispatch(set_save_disabled(disabled));
};

const setHasChanges = (hasChanges: boolean) => (dispatch: Dispatch) => {
  dispatch(set_has_changes(hasChanges));
};

export default {
  applyFiltersApi,
  setDrawTable,
  setSelectedEntityId,
  setSaveDisabled,
  setHasChanges
};
